<form role="form" [formGroup]="examForm">
  <h1 mat-dialog-title>{{data.title}}</h1>
  <div mat-dialog-content>
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Exam Date</mat-label>
        <input matInput type="date" formControlName="examDate" placeholder="Select Exam Date">
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="fill">
        <mat-label>Select Class</mat-label>
        <mat-select formControlName="Class_SysRef">
          <mat-option *ngFor="let class of (dataClassList$ | async)" [value]="class.sysRef">
            {{class.className}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="fill">
        <mat-label>Select Exam Type</mat-label>
        <mat-select formControlName="ExamType_SysRef">
          <mat-option *ngFor="let examType of (dataExamTypeList$ | async)" [value]="examType.sysRef">
            {{examType.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Enter Description</mat-label>
        <input matInput formControlName="description" placeholder="Enter the description of the exam">
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Pass Mark</mat-label>
        <input matInput type="number" formControlName="passMark" placeholder="Enter Pass Rate">
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Amout of Questions</mat-label>
        <input matInput formControlName="questionAmount" placeholder="Enter the amount of question the exam is to have">
      </mat-form-field>
    </p>

  </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">Close</button>
        <button mat-button cdkFocusInitial (click)="addExam()">Save</button>
    </div>
</form>
